import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "q-pa-md galano",
  style: {"background-color":"#F9F9F9"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Revisa el detalle de las ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" . ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Aviso sobre la prestación del servicio", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " El servicio de factoring ofrecido a través de esta plataforma es prestado directamente por IRIS, quien actúa como entidad responsable de la estructuración, negociación y ejecución de las operaciones realizadas por los usuarios. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " La plataforma tecnológica utilizada para la gestión y canalización de las operaciones es provista por RedCapital, quien actúa exclusivamente como proveedor tecnológico / sistema de negociación. ", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" RedCapital no participa como parte en las operaciones de factoring, no asume obligaciones financieras frente a los usuarios ni interviene en la decisión, aprobación o ejecución de las operaciones, las cuales son responsabilidad exclusiva de IRIS conforme a los términos y condiciones del servicio. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Snackbar = _resolveComponent("Snackbar")!
  const _component_PrivacityNotice = _resolveComponent("PrivacityNotice")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_layout, { view: "hHh LpR fff" }, {
      default: _withCtx(() => [
        _createVNode(_component_Navbar),
        ($setup.hideSidebar)
          ? (_openBlock(), _createBlock(_component_Sidebar, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_view),
        _createVNode(_component_Spinner),
        _createVNode(_component_Snackbar),
        ($setup.showPrivacityDialog)
          ? (_openBlock(), _createBlock(_component_PrivacityNotice, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(_component_q_footer, { class: "rc-service-footer text-center" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_2,
              _createElementVNode("button", {
                class: "rc-service-footer__link",
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openServiceModal && $setup.openServiceModal(...args)))
              }, " prestaciones de servicio "),
              _hoisted_3
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_q_dialog, {
          modelValue: $setup.showServiceModal,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.showServiceModal) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, { class: "rc-service-notice" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, { class: "rc-service-notice__title row justify-between no-wrap" }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createVNode(_component_q_btn, {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "close",
                      "aria-label": "Cerrar",
                      class: "rc-service-notice__close",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showServiceModal = false))
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, { class: "rc-service-notice__body" }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, { class: "rc-service-notice__alert" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}